var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reporting-grid-header" },
    [
      _c("BreakdownLegend", {
        attrs: {
          "group-bys": _vm.availableGroupBys,
          breakdown: _vm.activeInsightGroupHierarchy
        },
        on: { onChange: _vm.onGroupByChange, onDelete: _vm.onDeleteGroupBy }
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "clickable quick-insights-btn",
          on: {
            click: function($event) {
              return _vm.$emit("openQuickInsightsToolPanel")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-superpowers m-r-5" }),
          _vm._v("\n    Quick Insights\n  ")
        ]
      ),
      _vm._v(" "),
      !_vm.hideChartSelector
        ? _c("ChartSelector", {
            attrs: { "selected-chart-type": _vm.selectedChartType },
            on: { onChartTypeChange: _vm.selectChartType }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.canExport
        ? _c(
            "span",
            {
              staticClass: "export-csv-btn",
              on: {
                click: function($event) {
                  return _vm.$emit("exportSelectCols")
                }
              }
            },
            [
              _c("i", { staticClass: "fa fa-download m-r-5" }),
              _vm._v("\n    " + _vm._s(_vm.$t("EXPORT_CSV")) + "\n  ")
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }